import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const AirportSearchField = ({
  value,
  onChange,
  results,
  onSelect,
  onAddCustom,
  hasSearched,
  placeholder = "Search airport...",
  testId
}) => {
  const showNoResults = hasSearched && results.length === 0 && value.length >= 2 && !value.includes('(');

  return (
    <div className="relative">
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
      />
      {results.length > 0 && (
        <div className="absolute z-50 w-full bg-white border border-gray-200 rounded-md shadow-lg mt-1 max-h-60 overflow-y-auto">
          {results.map((airport) => (
            <div
              key={airport.iata}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => onSelect(airport)}
              data-testid={`airport-result-${airport.iata}`}
            >
              <div className="font-medium">{airport.iata} - {airport.name}</div>
              <div className="text-sm text-gray-500">{airport.city}, {airport.country}</div>
            </div>
          ))}
        </div>
      )}
      {showNoResults && (
        <div className="absolute z-50 w-full bg-white border border-gray-200 rounded-md shadow-lg mt-1">
          <div className="px-4 py-3 text-center">
            <p className="text-sm text-gray-600 mb-2">No airports found</p>
            {onAddCustom && (
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={onAddCustom}
                className="text-sky-600 hover:text-sky-700"
                data-testid="add-custom-airport-btn"
              >
                <Plus className="h-3 w-3 mr-1" />
                Add Custom Airport
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AirportSearchField;
